/**
 * Event bus de módulo para abrir o tour imperativamente de qualquer página
 * (ex.: botão "rever tutorial" no perfil), sem prop drilling até o overlay
 * global montado no App.
 *
 * Mesmo padrão do SurveyModal.
 */

export interface WalkthroughTriggerContext {
  /** Tour específico. Vazio = usa o primeiro pendente. */
  walkthroughId?: string;
  /** Recomeça do passo 0 mesmo que haja progresso salvo. */
  restart?: boolean;
}

type Listener = (context: WalkthroughTriggerContext) => void;

const listeners: Listener[] = [];

/** Assina os disparos manuais. Retorna a função de cancelamento. */
export function onWalkthroughTrigger(callback: Listener): () => void {
  listeners.push(callback);
  return () => {
    const index = listeners.indexOf(callback);
    if (index >= 0) listeners.splice(index, 1);
  };
}

/** Abre o tour a partir de qualquer lugar da aplicação. */
export function triggerWalkthrough(
  context: WalkthroughTriggerContext = {},
): void {
  listeners.forEach((listener) => listener(context));
}
